import { Typography } from "@mui/material";
import { LabelColumnV2 } from "../../components/DataGridV2/DataColumnsV2";
import { getGridContextMenuList } from "../../_helpers/getGridContextMenuList";
import { LOCAL_STORAGE_GRID_KEYS } from "../../_constants";

export const getSubContractorOverviewColumns = ({
  t,
  keyPrefix,
  i18n,
  apiRef,
  redirectToWorkOrderPage
}) => {
  const getOptions = getGridContextMenuList({
    filterKey: LOCAL_STORAGE_GRID_KEYS.SUB_CONTRACTOR_OVERVIEW_COLUMN_FILTER[keyPrefix],
    sortKey: LOCAL_STORAGE_GRID_KEYS.SUB_CONTRACTOR_OVERVIEW_COLUMN_SORT[keyPrefix],
    i18n,
    t,
    apiRef,
    mode: "client",
  })
  return [
    {
      download: true,
      print: true,
      field: "subContractorName",
      headerName: t("general.name"),
      flex: 1,
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={<Typography
              variant="caption"
              onClick={(e) =>
                redirectToWorkOrderPage(rowData.subContractorName, "subContractorName", rowData.organisatonId)
              }
            >
              {rowData.subContractorName}
            </Typography>}
            cellSubMenuOptions={{ options: getOptions({ field: "subContractorName", isQuickFilterDisplay: Boolean(rowData.subContractorName) }), extraData: { fieldName: "subContractorName" } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "newWorkOrder",
      headerName: t("general.workOrdersNew"),
      flex: 1,
      type:'number',
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={<Typography
              variant="caption"
              onClick={(e) =>
                redirectToWorkOrderPage(rowData.newWorkOrder, "newWorkOrder", rowData.organisatonId)
              }
            >
              {rowData.newWorkOrder}
            </Typography>}
            cellSubMenuOptions={{ options: getOptions({ field: "newWorkOrder", isQuickFilterDisplay: Boolean(rowData.newWorkOrder?.toString()) }), extraData: { fieldName: "newWorkOrder" , type:'number' } }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "inProgressWorkOrders",
      headerName: t("site.manager.open.work.orders"),
      flex: 1,
      type:'number',
      minWidth: 90,
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={<Typography
              variant="caption"
              onClick={(e) =>
                redirectToWorkOrderPage(rowData.inProgressWorkOrders, "inProgressWorkOrders", rowData.organisatonId)
              }
            >
              {rowData.inProgressWorkOrders}
            </Typography>}
            cellSubMenuOptions={{ options: getOptions({ field: "inProgressWorkOrders", isQuickFilterDisplay: Boolean(rowData.inProgressWorkOrders?.toString()) }), extraData: { fieldName: "inProgressWorkOrders" ,type:'number'} }}
            request={rowData}
          />
        );
      },
    },
    {
      download: true,
      print: true,
      field: "overdueWorkOrders",
      headerName: t("site.manager.overdue.work.orders"),
      flex: 1,
      minWidth: 90,
      type:'number',
      renderCell: (params) => {
        const rowData = params.row;
        return (
          <LabelColumnV2
            label={<Typography
              variant="caption"
              onClick={(e) =>
                redirectToWorkOrderPage(rowData.overdueWorkOrders, "overdueWorkOrders", rowData.organisatonId)
              }
            >
              {rowData.overdueWorkOrders}
            </Typography>}
            cellSubMenuOptions={{ options: getOptions({ field: "overdueWorkOrders", isQuickFilterDisplay: Boolean(rowData.overdueWorkOrders?.toString()) }), extraData: { fieldName: "overdueWorkOrders" , type:'number' } }}
            request={rowData}
          />
        );
      },
    },
  ]
}